const teamAcc = {
    init() {



        $('.js-button').on('click', function(){
            var $id = $(this).data('button');
            $(this).toggleClass('active');
            $('[data-id="'+ $id +'"] .the-content').slideToggle();
        });



    }
}

export {teamAcc}